import { call, takeLatest } from 'redux-saga/effects';
import { preloadStateActions as actions } from '.';
import { API_ENDPOINTS } from 'utils/configs';
import {
  ContentArrayPayload,
  UserSegmentPayload,
  UserMetaDataTypesPayload,
  SubAddOnTypesPayload,
  SubPlanTypePayload,
  CompanySsoConnectionTypePayload,
} from 'types/models';
import { UrlFragments } from 'app/constants';
import {
  handleGeneralGET,
  handleGeneralGETFnType,
} from 'utils/saga-helper/generalRequest';

const {
  user: { segments, metadata_types, roles },
  subscription: { addons, plans },
} = UrlFragments;

export function* fetchUserRoleSaga() {
  yield call<handleGeneralGETFnType<ContentArrayPayload<string>>>(
    handleGeneralGET,
    actions.fetchUserRoleSucceed,
    actions.fetchUserRoleFailed,
    API_ENDPOINTS.USER + roles,
  );
}

export function* fetchCompanySsoConnectionTypeSaga() {
  yield call<
    handleGeneralGETFnType<ContentArrayPayload<CompanySsoConnectionTypePayload>>
  >(
    handleGeneralGET,
    actions.fetchCompanySsoConnectionTypeSucceed,
    actions.fetchCompanySsoConnectionTypeFailed,
    API_ENDPOINTS.SSO_CONNECTION_TYPE,
  );
}

export function* fetchUserSegmentSaga() {
  yield call<handleGeneralGETFnType<ContentArrayPayload<UserSegmentPayload>>>(
    handleGeneralGET,
    actions.fetchUserSegmentSucceed,
    actions.fetchUserSegmentFailed,
    API_ENDPOINTS.USER + segments,
  );
}

export function* fetchUserMetaDataTypesSaga() {
  yield call<
    handleGeneralGETFnType<ContentArrayPayload<UserMetaDataTypesPayload>>
  >(
    handleGeneralGET,
    actions.fetchUserMetaDataTypesSucceed,
    actions.fetchUserMetaDataTypesFailed,
    API_ENDPOINTS.USER + metadata_types,
  );
}

export function* fetchSubAddonSaga() {
  yield call<handleGeneralGETFnType<ContentArrayPayload<SubAddOnTypesPayload>>>(
    handleGeneralGET,
    actions.fetchSubAddonSucceed,
    actions.fetchSubAddonFailed,
    API_ENDPOINTS.SUBSCRIPTION + addons,
  );
}

export function* fetchSubPlanTypeSaga() {
  yield call<handleGeneralGETFnType<ContentArrayPayload<SubPlanTypePayload>>>(
    handleGeneralGET,
    actions.fetchSubPlanTypeSucceed,
    actions.fetchSubPlanTypeFailed,
    API_ENDPOINTS.SUBSCRIPTION + plans,
  );
}

//TODO: The current block to merge all similar behaviours into one saga is the control of the race condition, takeEvery?
export function* preloadStateSaga() {
  yield takeLatest(actions.fetchUserRole.type, fetchUserRoleSaga);
  yield takeLatest(actions.fetchUserSegment.type, fetchUserSegmentSaga);
  yield takeLatest(
    actions.fetchUserMetaDataTypes.type,
    fetchUserMetaDataTypesSaga,
  );
  yield takeLatest(actions.fetchSubAddon.type, fetchSubAddonSaga);
  yield takeLatest(actions.fetchSubPlanType.type, fetchSubPlanTypeSaga);
  yield takeLatest(
    actions.fetchCompanySsoConnectionType.type,
    fetchCompanySsoConnectionTypeSaga,
  );
}
